<div class="flex flex-col justify-start items-start gap-4 p-2">
	<div class="mb-8 flex flex-col justify-start items-start">
		<img class="m-2 rounded-md object-cover w-[90%] md:w-auto max-h-[250px] md:aspect-square"
			 src="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/home/hero/home-hero-1.png" alt="">
		<h2 class="text-[#7d5b1f] text-lg font-semibold p-2">About Us</h2>
		<p class="text-sm pl-2 text-left">
			Discover Anuprerna’s sustainable handloom fabrics crafted by 300+ skilled artisans in East India. We also offer low MOQ custom manufacturing of apparel, stoles, scarves, handbags, and home furnishings in organic khadi, cotton, linen, wool, bamboo, mulberry, ahimsa silk and more.
		</p>
		<a [routerLink]="'/content/about-us/about-our-impact/57938'"
		   target="_blank"
		   class="w-max ml-1 bg-[#fffcf7] hover:bg-white hover:shadow-md rounded md:rounded-md border-2 border-[#8E7862] text-[#8E7862] py-1 px-3 hover:border-[#6c5b48]
						transition flex items-center justify-center gap-2 text-sm mt-4">
			Discover Our Impact
		</a>
	</div>

	<div class="mb-8 hidden md:flex flex-col justify-start items-start">

		<h2 class="text-[#7d5b1f] text-lg font-semibold px-2">Related Stories</h2>
		<div *ngFor="let recommended of storyRecommendedList"
			 class="w-full flex justify-start items-start gap-[1px] pr-2">
			<span class="material-symbols-outlined mt-0.5 text-[#7d5b1f]">arrow_right</span>
			<a [routerLink]="'/stories/' + recommended.slug + '/'+ recommended.id"
			   target="_blank"
			   class="my-1 text-xs capitalize hover:underline">
				{{recommended.title.toLowerCase()}}
			</a>
		</div>

		<div *ngIf="storyDetails.nextStoryDetails && storyDetails.nextStoryDetails.id"
			 class="w-full flex justify-start items-start gap-[1px] pr-2">
			<span class="material-symbols-outlined mt-0.5 text-[#7d5b1f]">arrow_right</span>
			<a [routerLink]="'/stories/' + storyDetails.nextStoryDetails.slug + '/'+ storyDetails.nextStoryDetails.id"
			   target="_blank"
			   class="my-1 text-xs capitalize hover:underline">
				{{storyDetails.nextStoryDetails.title.toLowerCase()}}
			</a>
		</div>

		<div *ngIf="storyDetails.previousStoryDetails && storyDetails.previousStoryDetails.id"
			 class="w-full flex justify-start items-start gap-[1px] pr-2 ">
			<span class="material-symbols-outlined mt-0.5 text-[#7d5b1f]">arrow_right</span>
			<a *ngIf="storyDetails.previousStoryDetails"
			   [routerLink]="'/stories/' + storyDetails.previousStoryDetails.slug + '/'+ storyDetails.previousStoryDetails.id"
			   target="_blank"
			   class="my-1 text-xs capitalize hover:underline fb-default-transition">
				{{storyDetails.previousStoryDetails.title.toLowerCase()}}
			</a>
		</div>
	</div>


</div>
